export enum RouteName {
	GATE_SURVEY = 'gateSurvey',
	PRE_QUESTION_SURVEY = 'preQuestionSurvey',
	HOME = 'home',
	OVERVIEW = 'overview',
	CHAPTER = 'chapter',
	OUTRO = 'outro',
	RESULT = 'result',
	USER_SURVEY = 'userSurvey'
}

export enum SiteId {
	MUNICIPALITY = 'municipality',
	ALL_ABOUT_DIET = 'allAboutDiet'
}

export enum UserGender {
	GENDER_FEMALE = 'female',
	GENDER_MALE = 'male',
	GENDER_OTHER = 'other'
}

export enum MutationType {
	SET_CURRENT_DOMAIN = 'set_current_domain',
	SET_CURRENT_CHAPTER = 'set_current_chapter',
	SET_CURRENT_THEME = 'set_current_theme',
	SET_CURRENT_SITE_TYPE = 'set_current_site_type',
	PUSH_INPUT = 'push_input',
	REMOVE_INPUT = 'remove_input',
	SAVE_INPUT_TO_LOCAL = 'save_input_to_local',
	PUSH_FINISHED_THEME = 'push_finished_theme',
	FINISH_GATE_SURVEY = 'finish_gate_survey',
	FINISH_PRE_QUESTIONS = 'finish_pre_questions',
	SAVE_PRE_QUESTIONS = 'save_pre_questions',
	PUSH_NO_PRODUCT_QUESTION = 'push_no_product_question',
	REMOVE_NO_PRODUCT_QUESTION = 'remove_no_product_question',
	INITIALIZE_STORE = 'initialize_store',
	RESET_STORE = 'reset_store',
	SET_USER_AGE = 'set_user_age',
	SET_USER_GENDER = 'set_user_gender',
	SET_SESSION_DURATION_START_TIME = 'set_session_duration_start_time',
	SET_SESSION_DURATION_END_TIME = 'set_session_duration_end_time',
	SET_SPECIAL_EVENT_ANSWERS = 'set_special_event_answers',
}

export enum Weekday {
	MONDAY = 'monday',
	TUESDAY = 'tuesday',
	WEDNESDAY = 'wednesday',
	THURSDAY = 'thursday',
	FRIDAY = 'friday',
	SATURDAY = 'saturday',
	SUNDAY = 'sunday'
}

export enum Weekend {
	SATURDAY = 'saturday',
	SUNDAY = 'sunday'
}

export enum Intake {
	FOOD = 'food',
	DRINKS = 'drinks',
	FOOD_PORTIONS = 'foodPortions',
	DRINKS_PORTIONS = 'drinksPortions'
}

export enum ResultCategory {
	RED = 'red',
	YELLOW = 'yellow',
	GREEN = 'green'
}

export enum SpecialEventIds {
	BIRTHDAY = 'birthday',
	GRANDPARENTS = 'grandparents',
	SOCIAL_EVENTS = 'socialEvents',
	EXCURSIONS = 'excursions',
	SLEEPOVER = 'sleepover',
	OTHER = 'other'
}
